var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isDesigner)?_c('div',{style:(_vm.textStyle)},[_c('pre',[_vm._v(_vm._s(_vm.textValue?_vm.textValue:_vm.designerValue))])]):_c('pre',{style:(_vm.textStyle),on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.fvalue))])])
}
var staticRenderFns = []

export { render, staticRenderFns }